var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper",class:{ 'fixed-header-wrapper': _vm.isFixed }},[(_vm.isChinese === 'lang_CN')?_c('ul',{staticClass:"top-menu-nav"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-icon"},[_c('a',{staticClass:"to-index",attrs:{"href":"/"}})])
}]

export { render, staticRenderFns }